// @flow
import { post } from '@an/nova-frontend-rest-client';
import Config from '../../config';

import type { Categories } from '../type';

export const uploadCsvFile = (fileJson: Categories) =>
  // $FlowFixMe
  post(`${Config.apiBaseUrl}/alms/category`, `category/upload`, {}, fileJson);
